// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 767.98px) {\n.apply[data-v-48986303] .c-button {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
